import { OrderStatus } from "/@/generated/graphql";

type StatusPresentation = { label: string; color: string };

const PRESENTATION_BY_STATUS: Record<`${OrderStatus}`, StatusPresentation> = {
  [OrderStatus.Draft]: { label: "Brouillon", color: "ink" },
  [OrderStatus.NeedToBeProcessed]: { label: "En cours", color: "brand" },
  [OrderStatus.Confirmed]: { label: "En cours", color: "brand" },
  [OrderStatus.WaitingForProduction]: {
    label: "En production",
    color: "violet",
  },
  [OrderStatus.Producing]: { label: "En production", color: "violet" },
  [OrderStatus.ProducingInTransit]: {
    label: "En production",
    color: "violet",
  },
  [OrderStatus.OpsShippingToday]: { label: "Expédiée", color: "emerald" },
  [OrderStatus.Shipped]: { label: "Expédiée", color: "emerald" },
  [OrderStatus.Delivered]: { label: "Livrée", color: "success" },
  [OrderStatus.OnHold]: { label: "À valider", color: "warning" },
  [OrderStatus.ShippedBackFromDoctor]: {
    label: "Retour demandé",
    color: "warning",
  },
};

export const getOrderStatusPresentation = (
  status: `${OrderStatus}`
): StatusPresentation => PRESENTATION_BY_STATUS[status];
